import request from "../utils/request";

export function wxLogin(data) {
  return request.post("/app/oauth/token", data);
}

